export const TEST_RESULT = Object.freeze({ PASS: 'pass', FAIL: 'fail' });

export const TEST_RESULT_COLORS = Object.freeze({ PASS: 'green', FAIL: 'red' });

export const TEST_RESULT_TRANSITION_TIMEOUT = 1000;


// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/constants.jsx